import { render, staticRenderFns } from "./changeBatch.vue?vue&type=template&id=59e3ffcc&scoped=true"
import script from "./changeBatch.vue?vue&type=script&lang=js"
export * from "./changeBatch.vue?vue&type=script&lang=js"
import style0 from "./changeBatch.vue?vue&type=style&index=0&id=59e3ffcc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e3ffcc",
  null
  
)

export default component.exports